import React, { useEffect, useState } from 'react'
import klalogo from '../../Assets/kla-logo.png'
import Logo_path from '../../Components/Logo_path'
import VideoPlayerBox from './VideoPlayerBox'
import { Icon } from '@iconify/react/dist/iconify.js'
function ViewVideo({videoData,handleCloseM}) {
  useEffect(()=>{
    console.log(videoData)
  },[videoData])
    const [isVideoView, setisVideoView] = useState(false)
    const [RelatedMembersInVideo,setRelatedMembersInVideo]=useState([5,6,7,8,3,4,5,8,9])

    return (
        <div className='flex w-full h-full justify-center' style={{ fontFamily: 'ropa sans' }}>
            <div className='flex flex-col w-full items-center'>
            <div className='flex justify-end items-start w-full pb-1'><div onClick={handleCloseM} className='flex justify-center items-center h-10 w-10 border-l border-b border-red-500 hover:bg-red-500 hover:text-white transform duration-500 ease-in-out cursor-pointer text-red-500'><Icon icon="iconamoon:close" className='text-2xl' /></div></div>

                {/* Section 1 logo directory*/}
                {/* <div className='md:w-11/12 w-11/12'>
                    <Logo_path AdminOrHome={'Admin'} Directory={'View'} />
                </div> */}

                {/* section3 video player */}
                <div className=' w-full mt-8'><VideoPlayerBox videourl={videoData?.video_url} thumb={videoData?.video_thumbnail}/> </div>

                {/* Buttons Actions to hide, edit and delete videos */}
                {/* <div className='flex flex-row justify-between md:w-9/12 w-11/12 mt-8'>
                    <div className='w-3/12 h-12'><button className='w-full h-full bg-white-600 rounded-xl text-black border border-blue-600 hover:bg-success text-xl'>Hide</button></div>
                    <div className='w-3/12 h-12'><button className='w-full h-full bg-blue-600 rounded-xl text-white text-xl'>Edit</button></div>
                    <div className='w-3/12 h-12'><button className='w-full h-full bg-red-600 rounded-xl text-white text-xl'>Delete</button></div>
                </div> */}

                {/*Section video title member name and description */}
                <div className='flex justify-between w-9/12 mt-10 mb-10 flex-row flex-wrap'>

                    <div className='flex flex-col w-full'>
                    {/* <div className='w-full'> <h1 className='text-2xl'>Video Title</h1></div> */}
                    <div className='w-full flex flex-col'>
                  <div className='mt-6'><p>{videoData?.video_subject}</p>
                  </div>

                  {/* display the kla */}
                  <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-3/12' style={{ color: '#606060' }}> <h2 className=''>KLA</h2></div>
                    <div className='w-9/12'>{videoData?.kla}</div>
                  </div>

                   {/* display session */}
                   <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-3/12' style={{ color: '#606060' }}> <h2 className=''>session</h2></div>
                    <div className='w-9/12'>{videoData?.video_session}</div>
                  </div>

                  {/* display event */}
                  <div className='w-11/12 flex flex-row mt-6 justify-center '>
                    <div className='text-grey-600 flex justify-start w-3/12' style={{ color: '#606060' }}> <h2 className=''>Event</h2></div>
                    <div className='w-9/12'>{videoData?.video_event}</div>
                  </div>

                   {/* display Sitting date */}
                  <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-3/12' style={{ color: '#606060' }}> <h2 className=''>Uploaded Date</h2></div>
                    <div className='w-9/12'>{videoData?.video_upload_date}</div>
                  </div>

                  <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-3/12' style={{ color: '#606060' }}> <h2 className=''>Mapping ID</h2></div>
                    <div className='w-9/12'>{videoData?.mapping_id}</div>
                  </div>

                  <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-3/12' style={{ color: '#606060' }}> <h2 className=''>Sequence number</h2></div>
                    <div className='w-9/12'>{videoData?.video_sequence_no}</div>
                  </div>

                  <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-3/12' style={{ color: '#606060' }}> <h2 className=''>Video URL</h2></div>
                    <div className='w-9/12'>{videoData?.video_url}</div>
                  </div>

                   {/* display Duration of the video*/}
                   {/* <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-6/12' style={{ color: '#606060' }}> <h2 className=''>Duration</h2></div>
                    <div className='w-6/12'>45 Minutes</div>
                  </div> */}

                   {/* display  size of the video*/}
                   {/* <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-6/12' style={{ color: '#606060' }}> <h2 className=''>Size</h2></div>
                    <div className='w-6/12'>12 GB</div>
                  </div> */}

                   {/* display the admin who added the video */}
                   <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-3/12' style={{ color: '#606060' }}> <h2 className=''>Added By</h2></div>
                    <div className='w-9/12'>{videoData?.uploaded_by}</div>
                  </div>

                   {/* display sequence number */}
                   {/* <div className='w-11/12 flex flex-row mt-6 justify-center'>
                    <div className='text-grey-600 flex justify-start w-3/12' style={{ color: '#606060' }}> <h2 className=''>Sequence number</h2></div>
                    <div className='w-6/12'>{videoData?.video_sequence_no}</div>
                  </div> */}

                  

                  </div>
                    </div>


                    {/* <div className='flex items-end md:w-4/12 w-full flex-col md:mt-0 mt-8'> 
                    <div className='w-8/12 '><h1 className='text-2xl md:text-center text-left'>Members</h1></div>

                    <div className='w-full flex flex-wrap md:justify-end justify-center mt-6 overflow-hidden overflow-y-scroll hide-scroll-bar' style={{height:'28rem'}}>
                      
 
                      {RelatedMembersInVideo.map((index,members)=>(
                        <div className='flex lg:w-8/12 w-10/12 h-14 justify-center items-center rounded-lg border border-blue-500 mt-3 ' key={index}>
                        <h2 className=' text-center'>Shri. Pinarayi Vijayan</h2>
                        </div>
                      )) }
                    </div>

                    </div> */}
                </div>

                  

                  

            </div>
        </div>
    )
}

export default ViewVideo